export default String.raw`
.validation-popup {
    .dialog {
        &__content {
            padding: 24px 16px 0 16px;
        }

        &__actions {
            padding: 16px;
            justify-content: center;
            flex-direction: column;
            gap: 12px;
        }
    }
}
`